import { gamesWithManyBetsOptions } from '@/api/bets/queries/useBetsOriginalsMe/games-with-many-bets.options';
import { BetsQueryKeys } from '@/api/bets/queryKey';
import { GameIDType } from '@/enums/gameId';
import { DetailedBet } from '@/models/detailed-bet';
import { betPlayingStatuses } from '@/utils/bets/transactions';
import { useAddNewRecordToInfiniteQuery } from '@starsoft/common/hooks';
import { Nullable } from '@starsoft/common/interfaces';
import { Either } from '@starsoft/common/services';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useBetSuccessCallback(gameId: GameIDType) {
  const queryClient = useQueryClient();
  const addNewDataToInfiniteQuery = useAddNewRecordToInfiniteQuery([
    BetsQueryKeys.MeInfinity,
    { gameId },
  ]);

  const onSuccess = useCallback(
    (data: DetailedBet) => {
      queryClient.setQueryData(
        [BetsQueryKeys.BetsOriginalsMe, { gameId }],
        (oldData: Nullable<Either<DetailedBet[], DetailedBet>>) => {
          if (!oldData) {
            return gamesWithManyBetsOptions.includes(gameId) ? [data] : data;
          }

          if (
            !Array.isArray(oldData) &&
            gamesWithManyBetsOptions.includes(gameId)
          ) {
            return [oldData, data];
          }

          if (Array.isArray(oldData)) {
            return oldData
              ?.filter(bet => bet?.id?.toString() !== data?.id?.toString())
              .concat(data);
          }

          return data;
        },
      );

      if (!betPlayingStatuses.includes(data?.status?.statusId?.toString())) {
        addNewDataToInfiniteQuery(data);
      }
    },
    [queryClient, gameId, addNewDataToInfiniteQuery],
  );

  return {
    onSuccess,
  };
}
